export default __webpack_public_path__ + "static/media/IC00026-agenda_org.5e00997c.svg";